/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IdentityCluster } from './IdentityCluster';
import {
    IdentityClusterFromJSON,
    IdentityClusterFromJSONTyped,
    IdentityClusterToJSON,
    IdentityClusterToJSONTyped,
} from './IdentityCluster';
import type { SourceReference } from './SourceReference';
import {
    SourceReferenceFromJSON,
    SourceReferenceFromJSONTyped,
    SourceReferenceToJSON,
    SourceReferenceToJSONTyped,
} from './SourceReference';
import type { FieldProvenance } from './FieldProvenance';
import {
    FieldProvenanceFromJSON,
    FieldProvenanceFromJSONTyped,
    FieldProvenanceToJSON,
    FieldProvenanceToJSONTyped,
} from './FieldProvenance';

/**
 * Golden record (master record)
 * @export
 * @interface GoldenRecord
 */
export interface GoldenRecord {
    /**
     * Golden record ID
     * @type {string}
     * @memberof GoldenRecord
     */
    id?: string;
    /**
     * Tenant ID
     * @type {string}
     * @memberof GoldenRecord
     */
    tenantId?: string;
    /**
     * Entity type
     * @type {string}
     * @memberof GoldenRecord
     */
    entityType?: string;
    /**
     * Merged golden data (best fields from all sources)
     * @type {{ [key: string]: any; }}
     * @memberof GoldenRecord
     */
    goldenData?: { [key: string]: any; };
    /**
     * Source entity references
     * @type {Array<SourceReference>}
     * @memberof GoldenRecord
     */
    sourceReferences?: Array<SourceReference>;
    /**
     * Field-level provenance (which source owns each field)
     * @type {{ [key: string]: FieldProvenance; }}
     * @memberof GoldenRecord
     */
    fieldProvenance?: { [key: string]: FieldProvenance; };
    /**
     * Identity cluster: observed identifiers with confidence and first/last seen (REQ-GOV-01)
     * @type {IdentityCluster}
     * @memberof GoldenRecord
     */
    identityCluster?: IdentityCluster;
    /**
     * Merge strategy used
     * @type {string}
     * @memberof GoldenRecord
     */
    mergeStrategy?: string;
    /**
     * Overall confidence score
     * @type {number}
     * @memberof GoldenRecord
     */
    confidenceScore?: number;
    /**
     * Record status
     * @type {string}
     * @memberof GoldenRecord
     */
    status?: string;
    /**
     * Number of source entities merged
     * @type {number}
     * @memberof GoldenRecord
     */
    sourceCount?: number;
    /**
     * Created timestamp
     * @type {Date}
     * @memberof GoldenRecord
     */
    createdAt?: Date;
    /**
     * Last updated timestamp
     * @type {Date}
     * @memberof GoldenRecord
     */
    updatedAt?: Date;
}

/**
 * Check if a given object implements the GoldenRecord interface.
 */
export function instanceOfGoldenRecord(value: object): value is GoldenRecord {
    return true;
}

export function GoldenRecordFromJSON(json: any): GoldenRecord {
    return GoldenRecordFromJSONTyped(json, false);
}

export function GoldenRecordFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoldenRecord {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'entityType': json['entityType'] == null ? undefined : json['entityType'],
        'goldenData': json['goldenData'] == null ? undefined : json['goldenData'],
        'sourceReferences': json['sourceReferences'] == null ? undefined : ((json['sourceReferences'] as Array<any>).map(SourceReferenceFromJSON)),
        'fieldProvenance': json['fieldProvenance'] == null ? undefined : (mapValues(json['fieldProvenance'], FieldProvenanceFromJSON)),
        'identityCluster': json['identityCluster'] == null ? undefined : IdentityClusterFromJSON(json['identityCluster']),
        'mergeStrategy': json['mergeStrategy'] == null ? undefined : json['mergeStrategy'],
        'confidenceScore': json['confidenceScore'] == null ? undefined : json['confidenceScore'],
        'status': json['status'] == null ? undefined : json['status'],
        'sourceCount': json['sourceCount'] == null ? undefined : json['sourceCount'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
    };
}

export function GoldenRecordToJSON(json: any): GoldenRecord {
    return GoldenRecordToJSONTyped(json, false);
}

export function GoldenRecordToJSONTyped(value?: GoldenRecord | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'tenantId': value['tenantId'],
        'entityType': value['entityType'],
        'goldenData': value['goldenData'],
        'sourceReferences': value['sourceReferences'] == null ? undefined : ((value['sourceReferences'] as Array<any>).map(SourceReferenceToJSON)),
        'fieldProvenance': value['fieldProvenance'] == null ? undefined : (mapValues(value['fieldProvenance'], FieldProvenanceToJSON)),
        'identityCluster': IdentityClusterToJSON(value['identityCluster']),
        'mergeStrategy': value['mergeStrategy'],
        'confidenceScore': value['confidenceScore'],
        'status': value['status'],
        'sourceCount': value['sourceCount'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
    };
}

